import 'alpinejs'

const componentsList = {}

export function createComponent(name, componentFn) {
  componentsList[name] = componentFn
}

function getComponent(name, ...props) {
  try {
    return componentsList[name](...props)
  } catch (error) {
    console.error(`component "${name}" has thrown an error and can't be run (see below)`)
    console.error(error)
  }
}

window.getComponent = getComponent
